export class AggregatorUtil {
    aggregate(data) {
        if (!data || data.length === 0) {
            return;
        }
        const lookup = {};
        const result = [];
        for (let i = 0; i < data.length; i++) {
            const temp = data[i];
            const deviceType = temp.Type;
            if (!(deviceType in lookup)) {
                lookup[deviceType] = 1;
                const resultObject = {
                    type: deviceType,
                    count: 1
                };
                result.push(resultObject);
            } else {
                for (let i = 0; i < result.length; i++) {
                    if (result[i].type === deviceType) {
                        result[i].count += 1;
                    }
                }
            }
        }
        return result;
    }
}
